import React, { useState } from "react";
import "./FeaturedSection.css";
import { useNavigate } from "react-router-dom";
import Loading from "../loading/Loading";

const FeaturedSection = () => {
  const [showItinerary, setShowItinerary] = useState(false);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleBookNow = () => {
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
      navigate("/tours/coron-to-el-nido-expedition");
      window.scrollTo(0, 0);
    }, 2000); // Simulate 2 seconds loading before navigation
  };

  const image =
    "https://img.freepik.com/free-photo/boats-ocean-surrounded-by-mountains-cloudy-sky_181624-39404.jpg?ga=GA1.1.987006646.1737491457&semt=ais_hybrid";
  const title = "Coron to El Nido Expedition";
  const subtitle = "Explore Palawan 3D2N";
  const description =
    "Discover breathtaking places with our exclusive travel packages, tailored just for you.";
  const price = "P15,000/pax";
  const inclusion = [
    "Entrance",
    "Environmental fees",
    "Beach Camp Accommodation (Bahay Kubo or Nipa Hut with Comfortable Mattress)",
    "Meals and Snacks (Filipino Cuisine with Seafood and Vegetarian Options)",
    "Drinking Water, Soft Drinks, and Alcoholic Beverages",
    "Mask and Snorkels, Kayak, Life Jacket, First Aid Box",
    "Free Electric Charging and Wi-Fi",
    "Bonfire and Fire Dance Show",
  ];
  const itinerary = [
    "Coron Port at 8:00am",
    "Ditaytayan Sandbar",
    "Ditaytayan Long Beach Camp",
    "Coral Garden",
    "Araw Beach",
    "Culion Beach Camp",
    "Buko Island",
    "Anapupuan Fisherman Village",
    "Doulbe 9 Cliff Jumping",
    "Cagdanao Deserted Island",
    "Linapacan Beach Camp",
    "Bulawit Turtle Conservation Area",
    "Cobra Island",
    "Tacling Island",
    "Daracutan Shipwreck",
    "El Nido San Fernando ETA 5:30pm",
  ];

  const featuredSectionContainer = {
    padding: "4rem 10%",
  };

  const containerStyle = {
    display: "flex",
    flexDirection: "row",
    borderRadius: "20px",
    boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
    overflow: "hidden",
  };

  const imageStyle = {
    flex: 1,
    width: "100%",
    height: "100%",
    objectFit: "cover",
  };

  const contentStyle = {
    flex: 1,
    padding: "20px",
    backgroundColor: "#fff",
  };

  const titleStyle = {
    fontSize: "24px",
    fontWeight: "bold",
    marginBottom: "10px",
  };

  const subtitleStyle = {
    fontSize: "18px",
    color: "#777",
    marginBottom: "5px",
  };

  const descriptionStyle = {
    color: "#555",
    marginBottom: "10px",
  };

  const priceStyle = {
    fontSize: "22px",
    fontWeight: "bold",
    color: "#147fad",
    marginBottom: "10px",
  };

  const listStyle = {
    color: "#555",
    marginBottom: "5px",
  };

  return (
    <div style={featuredSectionContainer} className="featuredContainer">
      {loading && <Loading />}
      <div style={containerStyle} className="container featuredContainer">
        <div style={{ flex: 1 }}>
          <img src={image} alt={title} style={imageStyle} loading="lazy" />
        </div>
        <div style={contentStyle}>
          <h2 style={titleStyle}>{title}</h2>
          <h3 style={subtitleStyle}>{subtitle}</h3>
          <p style={descriptionStyle}>{description}</p>
          <p style={priceStyle}>{price}</p>
          <button
            className={`bookNowButton ${loading ? "loading" : ""}`}
            onClick={handleBookNow}
            disabled={loading}
          >
            {loading ? "Processing..." : "Book Now"}
          </button>

          <h3 style={subtitleStyle}>Inclusions:</h3>
          <ul style={listStyle}>
            {inclusion.map((item, index) => (
              <li key={index}>{item}</li>
            ))}
          </ul>
          <h3
            onClick={() => setShowItinerary(!showItinerary)}
            className={`dropdownTitle ${showItinerary ? "active" : ""}`}
          >
            Itinerary {showItinerary ? "▲" : "▼"}
          </h3>

          {showItinerary && (
            <ul className="itineraryList" style={listStyle}>
              {itinerary.map((item, index) => (
                <li key={index}>{item}</li>
              ))}
            </ul>
          )}
        </div>
      </div>
    </div>
  );
};

export default FeaturedSection;
